/* eslint-disable max-lines */
/* eslint-disable max-len */
import React from 'react';
import {Checkbox, Popup} from 'semantic-ui-react';
import {CustomDropDown} from '../../../../manageOrders/components/internalCommons/customDropDown';
import {generateJson} from '../../../utils/dataByLineUtils';

export const tableHeaderStockWithProps = ({
  lists,
  fetchUpdateModelsLine,
  filters,
  isUserTde,
  dealerId,
}) => {
  const dealerHiddenColums = ['available', 'destinyText', 'observations'];
  const columns = [
    {
      'Header': () => <span className="header-title">DISPONIBLE</span>,
      'title': 'DISPONIBLE',
      'accessor': 'available',
      'width': 150,
      'Cell': ({row, filteredRows}) => {
        const currentValue = row.original.available;
        const handleChange = (data, field, newValue) => {
          const dataForQuery = generateJson(data, field, currentValue, newValue, filters);
          fetchUpdateModelsLine(dataForQuery);
        };
        return <Checkbox
          disabled={row?.original?.pdsCloseDate || row.original.vehType === 'O' ? true : false}
          checked={ row.original.available === 'S' ? true : false}
          onChange={(e, {checked}) =>
            handleChange(
              row.original,
              'available',
              checked ? 'S' : 'N'
            )
          }
          toggle
        />;
      },
    },
    {
      'Header': () => <span className="header-title">LÍNEA</span>,
      'title': 'LÍNEA',
      'accessor': 'line',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">PEDIDO</span>,
      'title': 'PEDIDO',
      'accessor': 'orderNumber',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">SFX</span>,
      'title': 'SFX',
      'accessor': 'sfx',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">MODELO (KATASHIKI)</span>,
      'title': 'MODELO (KATASHIKI)',
      'accessor': 'master',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">DESCRIPCIÓN</span>,
      'title': 'DESCRIPCIÓN',
      'accessor': 'description',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">COLOR EXTERNO</span>,
      'title': 'COLOR EXTERNO',
      'accessor': 'externalColor',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">CÓDIGO EXTERNO</span>,
      'title': 'CÓDIGO EXTERNO',
      'accessor': 'externalColorId',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">COLOR INTERNO</span>,
      'title': 'COLOR INTERNO',
      'accessor': 'internalColor',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">CÓDIGO INTERNO</span>,
      'title': 'CÓDIGO INTERNO',
      'accessor': 'internalColorId',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">CHASIS</span>,
      'title': 'CHASIS',
      'accessor': 'chassis',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">MOTOR</span>,
      'title': 'MOTOR',
      'accessor': 'motor',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">RAMV</span>,
      'title': 'RAMV',
      'accessor': 'ranmv',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">AÑO MODELO</span>,
      'title': 'AÑO MODELO',
      'accessor': 'yearModel',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">ETA</span>,
      'title': 'ETA',
      'accessor': 'modificationDate',
      'width': 150,
      'Cell': ({row}) => <>{row.original.modificationDate?.substring(0, 10) || ''}</>,
    },
    {
      'Header': () => <span className="header-title">FECHA DE FACTURACIÓN</span>,
      'title': 'FECHA DE FACTURACIÓN',
      'accessor': 'pdsCloseDate',
      'width': 150,
      'Cell': ({row}) => <>{row.original.pdsCloseDate?.substring(0, 10) || ''}</>,
    },
    {
      'Header': () => <span className="header-title">DIAS ANTIGUEDAD</span>,
      'title': 'DIAS ANTIGUEDAD',
      'accessor': 'daysOld',
      'width': 150,
      'Cell': ({row}) => {
        const getColor = (daysOld) => {
          if (daysOld < 30) {
            return 'color-green';
          } else if (daysOld >= 30 && daysOld <= 60) {
            return 'color-yellow';
          } else if (daysOld > 60) {
            return 'color-red';
          }
        };
        return (
          <div className={getColor(row.original.daysOld)}>
            {row.original.daysOld < 0 ?
              `en ${Math.abs(row.original.daysOld)} días` :
              `hace ${Math.abs(row.original.daysOld)} días`
            }
          </div>
        );
      },
    },
    {
      'Header': () => <span className="header-title">UBICACIÓN</span>,
      'title': 'UBICACIÓN',
      'accessor': 'locationText',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">ASIGNADO A</span>,
      'title': 'ASIGNADO A',
      'accessor': 'dealerName',
      'width': 150,
      'Cell': ({row}) => {
        const currentValue = row.original.dealerId;
        const handleDropdown = (data, field, newValue) => {
          const dataForQuery = generateJson(data, field, currentValue, newValue, filters);
          fetchUpdateModelsLine(dataForQuery);
        };
        if (!isUserTde) {
          return <div className={'selector-medium-size'}>{row.original.dealerName}</div>;
        }
        return (
          <CustomDropDown
            placeholder="Seleccionar dealer"
            className={'selector-medium-size'}
            value={row.original.dealerId}
            onChange={(e, {value}) =>
              handleDropdown(
                row.original,
                'dealer_id',
                value
              )
            }
            options={lists.listDealersAll}
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">OBSERVACIONES</span>,
      'title': 'OBSERVACIONES',
      'accessor': 'observations',
      'width': 150,
      'Cell': ({row}) => (
        <>
          <Popup
            trigger={
              <div className="dot">
                {row.original?.observations?.length || 0}
              </div>
            }
            position="top center"
            size="small"
            className="observations-popup"
            disabled={!row?.original?.observations?.length}
            inverted
          >
            <Popup.Header>Modificaciones en "Asignado A"</Popup.Header>
            <Popup.Content style={{'fontSize': '9px'}}>
              <table>
                {row?.original?.observations?.map((observation, index) => (
                  <tr>
                    <th>{observation.arrivalDate}:</th>
                    <th>{observation.dealerNameOld}</th>
                    <th>&rarr;</th>
                    <th>{observation.dealerNameNew}</th>
                  </tr>
                ))}
              </table>
            </Popup.Content>
          </Popup>
        </>
      ),
    },
    {
      'Header': () => <span className="header-title">FACTURAR A</span>,
      'title': 'FACTURAR A',
      'accessor': 'billingName',
      'width': 150,
      'Cell': ({row}) => {
        const currentValue = row.original.billingId;
        const handleDropdown = (data, field, newValue) => {
          const dataForQuery = generateJson(data, field, currentValue, newValue, filters);
          fetchUpdateModelsLine(dataForQuery);
        };
        if (!isUserTde) {
          return <div className={'selector-medium-size'}>{row.original.billingName}</div>;
        }
        return (
          <CustomDropDown
            placeholder="Seleccionar dealer"
            className={'selector-medium-size selector-custom-inventory'}
            value={row.original.billingId}
            onChange={(e, {value}) =>
              handleDropdown(
                row.original,
                'billing_ruc',
                value
              )
            }
            options={lists.listDealersAll}
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">IMPORTADOR</span>,
      'accessor': 'importerProgrammingName',
      'title': 'IMPORTADOR',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title">TIPO DE VENTA</span>,
      'title': 'TIPO DE VENTA',
      'accessor': 'vehTypeName',
      'width': 150,
      'Cell': ({row}) => {
        const currentValue = row.original.vehType;
        const handleDropdown = (data, field, newValue) => {
          const dataForQuery = generateJson(data, field, currentValue, newValue, filters);
          fetchUpdateModelsLine(dataForQuery);
        };
        if (!isUserTde) {
          return <div className={'selector-medium-size'}>{row.original.vehTypeName}</div>;
        }
        return (
          <CustomDropDown
            placeholder="Seleccionar tipo de venta"
            className={'.selector-small-size'}
            value={row.original.vehType}
            onChange={(e, {value}) =>
              handleDropdown(
                row.original,
                'veh_type',
                value
              )
            }
            options={
              ['N', 'U', 'G', 'O'].includes(row.original.vehType) ?
                lists.listVehiclesTypes.typesS1SU :
                lists.listVehiclesTypes.typesRest
            }
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">CLIENTE</span>,
      'title': 'CLIENTE',
      'accessor': 'clientName',
      'width': 150,
      'Cell': ({row}) => {
        if (isUserTde || row.original.dealerId === dealerId) {
          return (
            <>{row.original.clientName}</>
          );
        }
        return (
          <> </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">RUC CLIENTE</span>,
      'title': 'RUC CLIENTE',
      'accessor': 'clientId',
      'width': 150,
      'Cell': ({row}) => {
        if (isUserTde || row.original.dealerId === dealerId) {
          return (
            <>{row.original.clientId}</>
          );
        }
        return (
          <> </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">DESTINO</span>,
      'title': 'DESTINO',
      'accessor': 'destinyText',
      'width': 150,
    },
  ];

  if (isUserTde) {
    return columns;
  }
  return columns.filter((column) => !dealerHiddenColums.includes(column.accessor));
};
